import React, { Component } from "react";
import { fire, auth } from "../../firebase/index";
import { customLog } from "../../variables/Variables";
import AuthUserContext from "../../components/Auth/AuthUserContext";
//css
import "../../assets/css/maincss.css";
import "../../assets/css/header.css";
import LocalizedStrings from "react-localization";
let localizationStrings = new LocalizedStrings({
  en: {
    JAP: "Japanese",
    ENG: "English",
    ESP: "Spanish",
  },
  ja: {
    JAP: "日本語",
    ENG: "英語",
    ESP: "スペイン語",
  },
  es: {
    JAP: "Japonés",
    ENG: "Inglés",
    ESP: "Español",
  },
});

class LanguageSetting extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentLanguage: localizationStrings.getLanguage(),
      currentUserUID: "",
      loading: false,
    };

    //? Functions
    this.switchLanguage = this.switchLanguage.bind(this);
    this.switchLanguageButton = this.switchLanguageButton.bind(this);
  }

  componentWillMount() {
    this._authUnsub = auth.onAuthStateChanged((user) => {
      if (user) {
        // User is signed in.
        this.setState({
          currentUserUID: user.uid,
          loading: false,
        });

        fire
          .database()
          .ref("userSettings")
          .child(user.uid)
          .child("language")
          .on("value", this._langCb = (snapshot) => {
            customLog(snapshot.val());
            if (snapshot.val() === null) {
              fire
                .database()
                .ref("userSettings")
                .child(user.uid)
                .child("language")
                .set("en");

              this.setState({
                currentLanguage: localizationStrings.getLanguage(),
              });
              customLog(this.state.currentLanguage);
            } else {
              this.setState({
                currentLanguage: snapshot.val(),
              });
            }
          });
      }
    });
  }

  switchLanguage(event) {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .set(event.target.value);
    }
  }

  // switchLanguage() {
  //   customLog(this.state.currentLanguage);
  //   let settingRegistry = fire
  //     .database()
  //     .ref("userSettings")
  //     .child(auth.currentUser.uid);

  //   if (auth.currentUser !== null) {
  //     settingRegistry
  //       .child("language")
  //       .once("value")
  //       .then(snapshot => {
  //         // let currentLanguage = snapshot.val()

  //         let currentLanguage = snapshot.val();
  //         if (currentLanguage == "en") {
  //           settingRegistry.child("language").set("ja");
  //           localizationStrings.setLanguage("ja");
  //           this.setState({ currentLanguage: "ja" });
  //         } else if (currentLanguage == "ja") {
  //           settingRegistry.child("language").set("es");
  //           localizationStrings.setLanguage("es");
  //           this.setState({ currentLanguage: "es" });
  //         } else if (currentLanguage == "es") {
  //           settingRegistry.child("language").set("en");
  //           localizationStrings.setLanguage("en");
  //           this.setState({ currentLanguage: "en"});
  //         } else {
  //           if (this.state.currentLanguage === "en") {
  //             settingRegistry.child("language").set("ja");
  //             localizationStrings.setLanguage("ja");
  //             this.setState({ currentLanguage: "ja" });
  //           } else {
  //             settingRegistry.child("language").set("en");
  //             localizationStrings.setLanguage(
  //               localizationStrings.getLanguage()
  //             );
  //             this.setState({
  //               currentLanguage: localizationStrings.getLanguage()
  //             });
  //           }
  //         }
  //       });
  //   }
  // }

  switchLanguageButton() {
    return (
      <AuthUserContext.Consumer>
        {(authUser) => {
          if (authUser) {
            return (
              <div className="switchLanguageWrapper">
                <select
                  id="switchLanguageDropdown"
                  name="switchLanguageDropdown"
                  onChange={this.switchLanguage}
                  value={this.state.currentLanguage}
                >
                  <option value="en">[ENG] English</option>
                  <option value="ja">[JPN] 日本語</option>
                  {/* <option value="es">[SPA] Español</option> */}
                </select>
                {/* <button
                  className="switchLanguageBtn"
                  onClick={this.switchLanguage}
                >
                  {this.state.currentLanguage === "en"
                    ? localizationStrings.ENG
                    : this.state.currentLanguage === "ja"
                      ? localizationStrings.JAP
                      : localizationStrings.ESP}
                </button> */}
              </div>
            );
          }
        }}
      </AuthUserContext.Consumer>
    );
  }

  componentWillUnmount() {
    if (this._authUnsub) this._authUnsub();
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    if (this.state.currentLanguage == "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage == "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage == "es") {
      localizationStrings.setLanguage("es");
    }
    return <div> {this.switchLanguageButton()}</div>;
  }
}

export default LanguageSetting;
